import React from "react";
import Text from "../../components/typography/Text";
import Toggle from "../../components/toggles/Toggle";

const HowItWorks = ({ roles = [] }) => {
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const options = roles.map(({ label }, value) => ({ label, value }));
  return (
    <div className="oHomeHowItWorks" id="how-it-works">
      <h1>How it works</h1>
      <div
        className="oHomeHowItWorks_toggle"
        onClick={() => setCurrentIndex(currentIndex < 1 ? currentIndex + 1 : 0)}
      >
        <Toggle
          value={currentIndex}
          setValue={setCurrentIndex}
          options={options}
        />
      </div>
      <div className="oHomeHowItWorks_points">
        {roles[currentIndex] &&
          roles[currentIndex].point.map(({ title, description }, index) => (
            <div className="oHomeHowItWorks_point" key={title}>
              <div className="oHomeHowItWorks_filigrane">0{index + 1}</div>
              <h4>
                <div className="oHomeHowItWorks_index">0{index + 1}.</div>
                {title}
              </h4>
              <Text>{description}</Text>
            </div>
          ))}
      </div>
    </div>
  );
};

export default HowItWorks;
